module.exports = __webpack_public_path__ + "static/img/historical-marker-novalloy.e89a831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/historical/historical-marker-novalloy.jpg
// module id = 1032
// module chunks = 0